// Hide Header on scroll-down & Show on scroll-up
/*
let headerHeight = document.querySelector('#myheader').offsetHeight;
let headerHeightPX = "-" + headerHeight + "px";
let prevScrollpos = window.pageYOffset;

$(document).scroll(function(){
  if ( window.pageYOffset > 10 ){
    window.onscroll = function() {
    let currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        document.getElementById("myheader").style.top = "0";
      } 
      // Fix for Safari & other mobile browsers for negative YOffset values
      else if ( window.pageYOffset <= 0 ) {
        document.getElementById("myheader").style.top = "0";
      }  
      else {
        document.getElementById("myheader").style.top = headerHeightPX;
      }
      prevScrollpos = currentScrollPos;
    }
  } 
});
*/

console.log("custom loaded");

// ============================================================
// Clip-On PDP: Robust variant image switching
// Problem: theme.js dispatches variantImageChange/variantChange, but
// the native updateImageSet / updateVariantImage handlers fail after
// the first click on Clip-On products (image-set cache state goes stale
// or the featured_media lookup misses).
//
// Fix: listen to the document-level "variant:change" event (always
// dispatched), find the matching slide via the THUMB's data-id, and
// drive Flickity directly via its public selectCell API.
// Scoped to body[data-product-type="clip-on"] so other PDPs are untouched.
// ============================================================
(function () {
  function isClipOn() {
    return document.body && document.body.getAttribute("data-product-type") === "clip-on";
  }

  function getFlickityInstance(sliderEl) {
    if (typeof Flickity !== "undefined" && Flickity.data) {
      var f = Flickity.data(sliderEl);
      if (f) return f;
    }
    // Theme wraps Flickity in theme.Slideshow — try the jQuery data hook used by Flickity
    if (window.jQuery) {
      var $f = window.jQuery(sliderEl).data("flickity");
      if ($f) return $f;
    }
    return null;
  }

  function findSlideForVariant(scope, variant) {
    if (!variant) return null;
    var mediaId = (variant.featured_media && variant.featured_media.id) || null;
    var imageId = (variant.featured_image && variant.featured_image.id) || null;
    var lookupId = mediaId || imageId;
    if (!lookupId) return null;

    // The thumb has data-id=""; its data-index aligns with
    // the slide's data-index (both are forloop.index0 of product.media).
    var thumb = scope.querySelector('.product__thumb[data-id="' + lookupId + '"]');
    if (!thumb) return null;

    var slideIndex = thumb.getAttribute("data-index");
    if (slideIndex === null) return null;

    return scope.querySelector('.product-main-slide[data-index="' + slideIndex + '"]');
  }

  function switchSlide(variant) {
    var scope = document.querySelector('[data-product-images]') || document;
    var sliderEl = scope.querySelector('[data-product-photos]');
    if (!sliderEl) return;

    var slide = findSlideForVariant(scope, variant);
    if (!slide) return;

    var flkty = getFlickityInstance(sliderEl);
    if (!flkty) return;

    // selectCell accepts a DOM element and handles filtered/unfiltered cells.
    if (typeof flkty.selectCell === "function") {
      flkty.selectCell(slide, false, false);
      return;
    }
    // Fallback: select by numeric index among current cells.
    var cells = (flkty.cells || []).map(function (c) { return c.element; });
    var idx = cells.indexOf(slide);
    if (idx >= 0 && typeof flkty.select === "function") {
      flkty.select(idx, false, false);
    }
  }

  // Debounce so rapid clicks don't fight each other
  var pending = null;
  function onVariantChange(evt) {
    if (!isClipOn()) return;
    if (!evt || !evt.detail || !evt.detail.variant) return;
    var variant = evt.detail.variant;
    if (pending) cancelAnimationFrame(pending);
    pending = requestAnimationFrame(function () {
      pending = null;
      try { switchSlide(variant); } catch (e) { console.warn("[clip-on image switch]", e); }
    });
  }

  document.addEventListener("variant:change", onVariantChange);
  // Also listen on document for the section-level event in case bubbling differs
  document.addEventListener("variantChange", onVariantChange, true);
})();

// Fixed MantiManti

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

$(window).scroll(function () {
  $("#mantimanti").each(function () {
    if (isScrolledIntoView(this) === true) {
      $(this).addClass("fixed-manti");
    }
  });
});

$(".mantimanti-close").click(function () {
  $("#mantimanti").hide(100);
});

// ATC Collection

$(document).on("click", ".js_ATC_btn", function () {
  var _this = $(this),
    form_data = $(this).parents(".collection_product_form").serialize();

  $(_this).addClass("btn--loading");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: form_data,
    success: function (data) {
      $(_this).removeClass("btn--loading");
      if (data.quantity > 0) {
        $(_this).text("Remove from Cart").addClass("js_remove_from_cart_btn");
      } else {
        $(_this).text("Add to Cart").removeClass("js_remove_from_cart_btn");
      }
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: null,
            addToCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      $(_this).removeClass("btn--loading");
      console.log(error.responseJSON.description);
    },
  });
});

$(document).on("click", ".js_ATC_btn", function () {
  var _this = $(this),
    variant_id = $(this)
      .closest(".collection_product_form")
      .find('[name="id"]')
      .val();

  $(_this).addClass("btn--loading");

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      quantity: 0,
      id: variant_id,
    },
    success: function (data) {
      $(_this).removeClass("btn--loading");
      if (data.item_count > 0) {
        $(_this).text("Entfernen").addClass("js_remove_from_cart_btn");
      } else {
        $(_this)
          .text("Zum Probierset hinzufügen")
          .removeClass("js_remove_from_cart_btn");
      }
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:removed", {
          detail: {
            product: null,
            removeFromCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      $(_this).removeClass("btn--loading");
      console.log(error.responseJSON.description);
    },
  });
});

// Open Dropdown on Hover for Try-On

$(".variant_selectors select").hover(
  function () {
    $(this).attr("size", $("option").length);
  },
  function () {
    $(this).attr("size", 1);
  }
);

// FF: Try On Kit - Add to Cart Button + Remove from Cart Button + Update Cart Button
$(document).on(
  "change",
  ".new_customization .variant_option .single_variant input",
  function () {
    if (
      $(this)
        .parents(".new_customization")
        .find(".single_variant input:checked").length
    ) {
      $(this)
        .parents(".new_customization")
        .find(".add_to_cart_JS")
        .removeClass("disable_btn");
    } else {
      $(this)
        .parents(".new_customization")
        .find(".add_to_cart_JS")
        .addClass("disable_btn");
    }
  }
);

$(document).on(
  "click",
  ".new_customization .variant_option .add_to_cart_JS",
  function () {
    var variant_arr = [],
      $this_add_to_cart_JS = $(this);
    $(this)
      .parents(".variant_option")
      .find(".variant_option_box .single_variant input:checked")
      .each(function (index, single_val) {
        variant_arr.push({ quantity: 1, id: parseInt($(single_val).val()) });
      });
    let variant_add_arry = {
      items: variant_arr,
    };
    $(this).text("Hinzufügen...");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: variant_add_arry,
      dataType: "json",
      success: function (success) {
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".add_product")
          .addClass("hide");
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".variant_option")
          .addClass("hide");
        $($this_add_to_cart_JS)
          .parents(".new_customization")
          .find(".remove_product")
          .removeClass("hide");
        $($this_add_to_cart_JS).text("Auswahl hinzufügen");
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: null,
              addToCartBtn: null,
            },
          })
        );
      },
      error: function (error) {
        $($this_add_to_cart_JS).text("Auswahl hinzufügen");
        alert(error.responseJSON["description"]);
      },
    });
  }
);

$(document).on("click", ".new_customization .remove_product", function () {
  var remove_variant = {},
    $this_remove_product = $(this);
  $(this)
    .parents(".new_customization")
    .find(".variant_option_box .single_variant input:checked")
    .each(function (index, single_val) {
      remove_variant[parseInt($(single_val).val())] = 0;
    });
  let remove_added_var = {
    updates: remove_variant,
  };
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: remove_added_var,
    dataType: "json",
    success: function (success) {
      $($this_remove_product)
        .parents(".new_customization")
        .find(".add_product")
        .removeClass("hide");
      $($this_remove_product)
        .parents(".new_customization")
        .find(".variant_option")
        .removeClass("hide");
      $($this_remove_product).addClass("hide");
      $($this_remove_product)
        .parents(".new_customization")
        .find(".variant_option_box .single_variant input:checked")
        .each(function (index, single_val) {
          $(this)
            .parents(".new_customization")
            .find(".add_to_cart_JS")
            .addClass("disable_btn");
          $(single_val).prop("checked", false);
        });
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: null,
            addToCartBtn: null,
          },
        })
      );
    },
    error: function (error) {
      alert(error.responseJSON["description"]);
    },
  });
});

// ATC PDP - Try On Product on PDP
/*
$(document).on('click', '.js_ATC_btn_pdp', function(){
  
  var _this = $(this),
      variant_id = 46854347063643;

  $(_this).addClass('btn--loading');

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      quantity: 1,
      id: variant_id
    },
    error:function(error){
      $(_this).removeClass('btn--loading');
      console.log(error.responseJSON.description);
    }
  });
});  
*/

function addCart(id) {
  jQuery.post(window.Shopify.routes.root + "cart/add.js", {
    items: [
      {
        quantity: 1,
        id: id,
      },
    ],
  }).done(function() {
    var url = $(location).attr("href");
    if (url.indexOf("?added") >= 0) {
      window.location.href = url;
      //code to update and open ajax cart
      var cart = new theme.CartDrawer();
      cart.init();
      cart.open();
    } else {
      window.location.href = url + "?added";
      //code to update and open ajax cart
      var cart = new theme.CartDrawer();
      cart.init();
      cart.open();
    }
  });
}

$(document).ready(function () {
  if (window.location.href.indexOf("added") > -1) {
    //code to update and open ajax cart
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  }
});

// Lens Advisor

document.addEventListener("LensAdvizor:init:complete", function () {
  LensAdvizor.options.settings.post_add_to_cart = true;
  LensAdvizor.postAddToCart = function () {
    //code to update and open ajax cart
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  };
});

/* Fitting Box - Virtual Try On */
/*
window.fitmixInstance = FitMix.createWidget("my-fitmix-container", params, function() {
  console.log('FMI created.');
});

window.onload = function () {
  var params = {
    apiKey: "SXeynuamTfjaZS7mmzQGNmy1IcwWUEupbBFQnqnv", 
    popupIntegration: {
      centeredHorizontal: true,
      centeredVertical: true,
      width: "780px",
      height: "560px",
    },
  };
};
*/

/*
window.onload = function() { 
  window.fitmixInstance = FitMix.createWidget('fitmix-container', params, function() {
  }
}
*/
// New Cart

async function returnCart() {
  try {
    const response = await fetch("/cart.json");
    if (!response.ok) {
      throw new Error("Failed to fetch cart data");
    }

    const cartData = await response.json();
    const cartItems = cartData.items || [];
    const cartPriceBetween0and488 = cartData.total_price <= 488;

    // Check if any cart item has "Try On" in its product title
    const tryOnItems = cartItems.filter((item) => {
      return (
        item.product_title &&
        item.product_title.toLowerCase().includes("try on") &&
        !item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      );
    });

    const tryOnSelectionItems = cartItems.filter((item) => {
      return (
        item.product_title &&
        item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      );
    });

    const cartNonTryOn = cartItems.filter((item) => {
      return (
        item.product_title &&
        !item.product_title.toLowerCase().includes("try on")
      );
    });

    // Determine the number of try-on items in cart
    const isOneTryOnItem = tryOnItems.length === 1;
    const isTwoTryOnItem = tryOnItems.length === 2;
    const isThreeTryOnItem = tryOnItems.length === 3;
    const isFourTryOnItem = tryOnItems.length === 4;
    const isFiveTryOnItem = tryOnItems.length === 5;
    const isNoTryOnItem = cartNonTryOn.length > 0;

    return {
      cartData,
      tryOnItems,
      isNoTryOnItem,
      tryOnSelectionItems,
      cartPriceBetween0and488,
    };
  } catch (error) {
    throw error;
  }
}

returnCart()
  .then((result) => {
    const cartData = result.cartData;

    const isNoTryOnItem = result.isNoTryOnItem;

    const reorderedCartItems = cartData.items.sort((a, b) => {
      const aIsTryOn =
        a.product_title && a.product_title.toLowerCase().includes("try on");
      const bIsTryOn =
        b.product_title && b.product_title.toLowerCase().includes("try on");

      if (aIsTryOn && !bIsTryOn) {
        return -1;
      }
      if (!aIsTryOn && bIsTryOn) {
        return 1;
      }
      return 0;
    });

    // Update cartData.items with the reordered items
    cartData.items = reorderedCartItems;
    // There is a needed delay here so that the cart can first get built before reassigning a different order for all elements inside of it
    setTimeout(() => {
      setDOMOrder(reorderedCartItems);
    }, 650); // 400ms delay
  })
  .catch((error) => {
    console.error("Error:", error);
  });

document.addEventListener("cart:updated", function (evt) {
  returnCart()
    .then((result) => {
      const cartData = result.cartData;

      const isNoTryOnItem = result.isNoTryOnItem;
    })
    .catch((error) => {
      console.error(error);
    });
});

document.addEventListener("ajaxProduct:added", function (evt) {
  returnCart()
    .then((result) => {
      const cartData = result.cartData;
      const cartPriceBetween0and488 = cartData.total_price <= 488;
      const isNoTryOnItem = result.isNoTryOnItem;

      const reorderedCartItems = cartData.items.sort((a, b) => {
        const aIsTryOn =
          a.product_title && a.product_title.toLowerCase().includes("try on");
        const bIsTryOn =
          b.product_title && b.product_title.toLowerCase().includes("try on");

        if (aIsTryOn && !bIsTryOn) {
          return -1;
        }
        if (!aIsTryOn && bIsTryOn) {
          return 1;
        }
        return 0;
      });

      // Update cartData.items with the reordered items
      cartData.items = reorderedCartItems;
      // There is a needed delay here so that the cart can first get built before reassigning a different order for all elements inside of it
      setTimeout(() => {
        setDOMOrder(reorderedCartItems, cartPriceBetween0and488);
      }, 650); // 400ms delay
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated:", evt.detail.cart);

  // Fetch the updated cart data
  returnCart()
    .then((result) => {
      const cartData = result.cartData;
      const cartPriceBetween0and488 = cartData.total_price <= 488;

      // Sort the cart items
      const reorderedCartItems = cartData.items.sort((a, b) => {
        const aIsTryOn =
          a.product_title && a.product_title.toLowerCase().includes("try on");
        const bIsTryOn =
          b.product_title && b.product_title.toLowerCase().includes("try on");

        if (aIsTryOn && !bIsTryOn) {
          return -1;
        }
        if (!aIsTryOn && bIsTryOn) {
          return 1;
        }
        return 0;
      });

      // Update cartData.items with the reordered items
      cartData.items = reorderedCartItems;

      // Set the order property for each DOM element
      setTimeout(() => {
        setDOMOrder(reorderedCartItems, cartPriceBetween0and488);
      }, 650); // 400ms delay
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

function setDOMOrder(sortedCartItems, cartPriceBetween0and488) {
  let hasTryOnItem = false;
  let hasNonTryOnItem = false;
  let hasLenseItem = false;
  let lastTryOnIndex = -1;
  let tryOnSelectionItems = false;
  const linksForTryOnElement = document.getElementById("links--for-try-on");
  sortedCartItems.forEach((item, index) => {
    const itemElement = document.querySelector(
      `.cart__item[data-key="${item.key}"]`
    );

    if (itemElement) {
      if (
        item.product_title &&
        item.product_title.toLowerCase().includes("manti")
      ) {
        hasLenseItem = true;
      }
      if (
        item.product_title &&
        // Check if it has more empty spaces
        item.product_title.toLowerCase().includes("try on") &&
        !item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      ) {
        hasTryOnItem = true;
        lastTryOnIndex = index;
        itemElement.style.order = index;
      } else if (
        item.product_title
          .toLowerCase()
          .replace(/\s+/g, " ")
          .includes("try on selection")
      ) {
        tryOnSelectionItems = true;
      } else {
        hasNonTryOnItem = true;
        itemElement.style.order = index + 2;
      }
    }
  });

  // Check if the element with id "additional-products--text" does not exist
  if (!document.getElementById("additional-products--text")) {
    if (hasTryOnItem && hasNonTryOnItem && !cartPriceBetween0and488) {
      console.log("Both try-on and non-try-on items in cart");
      // Create the new element
      const newElement = document.createElement("div");
      newElement.className = "cart-subheader padding--gutter";
      newElement.id = "additional-products--text";
      newElement.innerHTML = `<h4 style="margin-top: 14px;" class="albus h5">Weitere Artikel: </h4>`;
      newElement.style.order = lastTryOnIndex + 2;

      // Append the new element to the parent container
      const parentContainer = document.querySelector(".cart__items");
      if (parentContainer) {
        parentContainer.appendChild(newElement);
      }

      // Set the order for the links--for-try-on element
      if (linksForTryOnElement) {
        linksForTryOnElement.style.order = lastTryOnIndex + 1;
      }
      document.querySelector(".ajaxcart__subtotal").style.cssText = `
      font-size: inherit;
      font-style: normal;
      font-weight: inherit;
      line-height: inherit;
      letter-spacing: inherit;
`;
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.querySelector(".ajaxcart__subtotal").textContent =
        "ZWISCHENSUMME";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe:";
      document.getElementById("sidecart--state-subheading").style.display =
        "none";
    } else if (hasTryOnItem && !hasNonTryOnItem && !cartPriceBetween0and488) {
      console.log("Only try-on items in cart");
      // If there are only try-on items, set the links--for-try-on to be at the end
      linksForTryOnElement.style.order = lastTryOnIndex + 1;

      document.querySelector(".tryonproducts-text-container").style.display =
        "flex";
      document.querySelector(".ajaxcart__subtotal").textContent =
        "Du zahlst nur die Versandkosten";
      document.querySelector(".ajaxcart__subtotal").style.cssText = `
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 180% */
        letter-spacing: 1.275px;
`;
      // document.querySelector(".data--subtotal--text").textContent = "€ 4,90";
      document.getElementById("shippingIndicator").textContent =
        "Brillen zu Hause anprobieren";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "block";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Lege bis zu 5 Brillen in deine Anprobebox und probiere diese 7 Tage zu Hause.";
      document.getElementById("shipping-value-down").textContent = "€ 6,90";
    } else if (
      tryOnSelectionItems &&
      !hasNonTryOnItem &&
      !cartPriceBetween0and488
    ) {
      console.log("Only try-on selection items in cart");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      document.getElementById("shipping-value-down").textContent = "kostenlos";
    } else if (cartPriceBetween0and488) {
      console.log("Cart Price between 0 and 488");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Deine Brillen zur Anprobe";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("sidecart--state-subheading").innerHTML =
        "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>1,80€</span>";
      document.getElementById("shipping-value-down").textContent = "1,80€";
    } else {
      console.log("Only non-try-on items in cart");
      document.getElementById("shippingIndicator").textContent = "Versand";
      document.getElementById("sidecart--state-heading").textContent =
        "Augen auf! Hier ist deine Bestellung";
      document.getElementById("sidecart--state-subheading").style.display =
        "flex";
      document.getElementById(
        "sidecart--state-subheading"
      ).style.justifyContent = "space-between";
      document.getElementById("sidecart--state-subheading").style.color =
        "#000";
      document.getElementById("shipping-value-down").textContent = "kostenlos";

      if (hasLenseItem) {
        document.getElementById("sidecart--state-subheading").innerHTML =
          "Versand (3-7 Tage) <span  class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      } else {
        document.getElementById("sidecart--state-subheading").innerHTML =
          "Versand (2-5 Tage) <span class='shippingValue' id='only--nontryitems-span'>kostenlos</span>";
      }
    }
  }
}

// async function updateShippingCostDisplay() {
//   try {
//     const response = await fetch("/cart.json");
//     if (!response.ok) {
//       throw new Error("Failed to fetch cart data");
//     }

//     const cartData = await response.json();
//     const cartValue = cartData.total_price || 0; // Assuming total_price is in cents

//     // Select the element(s) with the class 'shippingValue'
//     const shippingCostElements = document.querySelectorAll(".shippingValue");

//  /*
//     // Update the text content based on the cart value
//     shippingCostElements.forEach(element => {
//       element.textContent = cartValue < 5000 ? "4,90€" : "kostenlos"; // Assuming the threshold is 50€ (5000 cents)
//     });
// */

// // OpenAI generated multiple case statements instead of if for lower shipping fee for small spare parts (15.06.2024)
//     shippingCostElements.forEach(element => {
//       let shippingCost;

//       if (cartValue === 0) {
//         shippingCost = "4,90€";
//       } else if (cartValue >= 1 && cartValue <= 489) {
//         shippingCost = "1,80€";
//       } else if (cartValue >= 490 && cartValue < 5000) {
//         shippingCost = "4,90€";
//       } else {
//         shippingCost = "kostenlos";
//       }

//       element.textContent = shippingCost;
//     });

//   } catch (error) {
//     console.error("Error updating shipping cost display:", error);
//   }
// }

// Call the function to update the shipping cost display
// updateShippingCostDisplay();

// Optionally, listen for cart updates to refresh the shipping cost display
// document.addEventListener("cart:updated", updateShippingCostDisplay);

// // Kostenlos / 4,90 Shipping Costs in Cart

// function checkAndUpdateShippingCost() {
//   setTimeout(() => {
//     fetch("/cart.json")
//       .then(response => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch cart data");
//         }
//         return response.json();
//       })
//       .then(cartData => {
//         const cartValue = cartData.total_price || 0; // Assuming total_price is in cents
//         const shippingCostText = cartValue >= 5000 ? "kostenlos" : "€ 4,90";
//         const shippingCostElements = document.querySelectorAll(".shippingValue");

//         shippingCostElements.forEach(element => {
//           element.textContent = shippingCostText;
//         });
//       })
//       .catch(error => {
//         console.error("Error updating shipping cost:", error);
//       });
//   }, 700);
// }

// // Run on page load
// document.addEventListener("DOMContentLoaded", checkAndUpdateShippingCost);

// // Run when the cart updates
// document.addEventListener("cart:updated", checkAndUpdateShippingCost);

// // Run when a product is added to the cart
// document.addEventListener("ajaxProduct:added", checkAndUpdateShippingCost);
